import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, _) => {
  const { code, quantity, cycle } = to.query;
  const query = to.query;
  const codes = query['code[]'];

  // codes: 配列でない場合,要素数が0 はNG。
  // code: 0, 空文字, undefined, null はNG。
  // quantity: 0, 空文字, undefined, null, 数値でないものはNG（全体が数値でないとNG）
  if (codes) {
    if (!Array.isArray(codes) || codes.length === 0) {
      return navigateTo('/');
    }
  } else {
    if (!code || code === '0' || code === '') {
      return navigateTo('/');
    }
  }

  if (!quantity || quantity === '0' || quantity === '' || isNaN(Number(quantity))) {
    return navigateTo('/');
  }

  // cycleが指定されている場合、0, 空文字, 空白, 数値でないものはNG（全体が数値でないとNG）
  if (cycle !== undefined && cycle !== null) {
    const cycleStr = String(cycle).trim();
    if (cycleStr === '' || isNaN(Number(cycleStr)) || Number(cycleStr) === 0) {
      return navigateTo('/');
    }
  }
});
